module.exports = __webpack_public_path__ + "static/push-1212a1ec384d029340f7449f6acd2759.jpg";